import { render, staticRenderFns } from "./chaternewptclass.vue?vue&type=template&id=9207ca2e&scoped=true"
import script from "./chaternewptclass.vue?vue&type=script&lang=js"
export * from "./chaternewptclass.vue?vue&type=script&lang=js"
import style0 from "./chaternewptclass.vue?vue&type=style&index=0&id=9207ca2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9207ca2e",
  null
  
)

export default component.exports